import ScrollAnimation from 'core/ScrollAnimation';
import { sanitize } from 'isomorphic-dompurify';

import cn from './style.module.sass';

type TitleCaseHeaderProps = {
    title: string;
    subtitle?: string;
};

export default function TitleCaseTop({ title, subtitle }: TitleCaseHeaderProps) {
    return (
        <ScrollAnimation className={cn.titleCaseHeader}>
            <h1
                dangerouslySetInnerHTML={{ __html: sanitize(title) }}
                className={cn['titleCaseHeader__title']}
            />
            {subtitle && (
                <div
                    dangerouslySetInnerHTML={{ __html: sanitize(subtitle) }}
                    className={cn['titleCaseHeader__subtitle']}
                />
            )}
        </ScrollAnimation>
    );
}
